<div class="copyright">
    <span>This site uses no cookies.</span>
    &nbsp{version}
    &nbsp Copyright &copy; Jeff watkins {year}
</div>

<style>
.copyright {
    font-size: 1vh;
    text-align: center;
}
</style>

<script>
    import {VERSION} from "./version";

    let year = `${new Date().getFullYear()}`;
    let version = `Version: ${VERSION}`;
</script>